// this endpoint is for using in Activity
// it returns all members including removed ones
// to be able to perform search
// for MSP sub accounts it fetches members from both root and sub accounts
import { all, put, takeEvery, select } from "redux-saga/effects";
import { authorizedApi } from "tools/apiConfigurator";
import requestWithSubTenantIfNeeded, {
  currentSubTenantSelector,
} from "../requestWithSubTenantIfNeeded";
import * as actions from "@p81-common/shell-core-js/dist/redux/membersAllGet";
import { formatMember } from "store/api/organization/membersGet/membersGetSaga";

export function request(projection = 1) {
  return requestWithSubTenantIfNeeded("get", "members/all", {
    searchParams: { projection },
  });
}

function* membersAllGet({ payload = {} }) {
  try {
    let { withTerminated, withRoot, projection } = payload;
    let allMembers;
    if (withRoot) {
      let requests = [request(projection)];
      let subTenantId = yield select(currentSubTenantSelector);
      if (subTenantId) {
        requests.push(authorizedApi.get("members/all").json());
      }
      let [responseFromSubtenant, responseFromRoot] = yield all(requests);
      allMembers = responseFromSubtenant.data.members;

      if (responseFromRoot) {
        allMembers.push(...responseFromRoot.data.members);
      }
    } else {
      let response = yield request(projection);
      allMembers = response.data.members;
    }

    if (!withTerminated) {
      allMembers = allMembers.filter((member) => !member.terminated);
    }

    yield put(actions.requestSuccess(allMembers.map(formatMember), payload));
  } catch (error) {
    yield put(actions.requestFailure(error, payload));
  }
}

function* saga() {
  yield takeEvery(actions.MEMBERS_ALL_GET_REQUEST, membersAllGet);
}

export default saga;
